// extracted by mini-css-extract-plugin
var _1 = "BAGradeLogo__main--QftP4";
export { _1 as "main" }
